// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".smileys-wrapper[data-v-260f563a]{display:flex;flex-flow:row wrap;justify-content:flex-end}.smiley[data-v-260f563a]{font-size:2em;font-family:Noto Color Emoji,Apple Color Emoji,Segoe UI Emoji,Times,Symbola,Aegyptus,Code2000,Code2001,Code2002,Musica,serif,LastResort!important}.disabled[data-v-260f563a]{cursor:not-allowed;filter:grayscale(100%)}", ""]);
// Exports
module.exports = exports;
